import React from "react";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";

const GAGuide = () => {
    const navigate = useNavigate();

    return (
        <div className="min-h-screen bg-slate-50 py-12 px-4 sm:px-6 lg:px-8 font-Montserrat">
            <div className="max-w-3xl mx-auto">
                <button
                    onClick={() => navigate(-1)}
                    className="mb-6 text-emerald-600 hover:text-emerald-700 font-medium flex items-center gap-2 transition-colors"
                >
                    ← Back
                </button>

                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    className="bg-white rounded-xl shadow-lg overflow-hidden"
                >
                    <div className="bg-emerald-600 px-6 py-8 sm:px-10">
                        <h1 className="text-3xl font-bold text-white">
                            How to find your Google Analytics Measurement ID
                        </h1>
                        <p className="mt-2 text-emerald-100 text-lg">
                            Track your Link Forest profile visitors with your own Google Analytics account.
                        </p>
                    </div>

                    <div className="px-6 py-8 sm:px-10 space-y-8">
                        <section>
                            <h2 className="text-xl font-bold text-slate-900 mb-4 flex items-center gap-3">
                                <span className="flex items-center justify-center w-8 h-8 rounded-full bg-emerald-100 text-emerald-600 text-sm">1</span>
                                Create a Google Analytics Account
                            </h2>
                            <p className="text-slate-600 ml-11">
                                Go to <a href="https://analytics.google.com/" target="_blank" rel="noreferrer" className="text-emerald-600 hover:underline">analytics.google.com</a> and sign in with your Google account. Click "Start measuring" if you don't have an account yet.
                            </p>
                        </section>

                        <section>
                            <h2 className="text-xl font-bold text-slate-900 mb-4 flex items-center gap-3">
                                <span className="flex items-center justify-center w-8 h-8 rounded-full bg-emerald-100 text-emerald-600 text-sm">2</span>
                                Create a Property
                            </h2>
                            <div className="ml-11 space-y-3 text-slate-600">
                                <p>1. In the Admin section, click <strong>Create Property</strong>.</p>
                                <p>2. Enter a name (e.g., "My Link Forest Profile").</p>
                                <p>3. Select your time zone and currency.</p>
                                <p>4. Click Next and select your industry/business size (optional).</p>
                                <p>5. Click Create.</p>
                            </div>
                        </section>

                        <section>
                            <h2 className="text-xl font-bold text-slate-900 mb-4 flex items-center gap-3">
                                <span className="flex items-center justify-center w-8 h-8 rounded-full bg-emerald-100 text-emerald-600 text-sm">3</span>
                                Set up a Data Stream
                            </h2>
                            <div className="ml-11 space-y-3 text-slate-600">
                                <p>1. Choose <strong>Web</strong> as your platform.</p>
                                <p>2. In the Website URL field, enter: <strong>linkforest.netlify.app</strong> (or your custom domain if applicable).</p>
                                <p>3. Enter a stream name (e.g., "Link Forest Profile").</p>
                                <p>4. Click <strong>Create stream</strong>.</p>
                            </div>
                        </section>

                        <section>
                            <h2 className="text-xl font-bold text-slate-900 mb-4 flex items-center gap-3">
                                <span className="flex items-center justify-center w-8 h-8 rounded-full bg-emerald-100 text-emerald-600 text-sm">4</span>
                                Copy your Measurement ID
                            </h2>
                            <div className="ml-11 space-y-4">
                                <p className="text-slate-600">
                                    You will see your <strong>Measurement ID</strong> in the top right corner. It starts with "G-".
                                </p>
                                <div className="bg-slate-100 p-4 rounded-lg border border-slate-200 font-mono text-sm text-slate-700">
                                    Example: G-XXXXXXXXXX
                                </div>
                                <p className="text-slate-600">
                                    Copy this ID and paste it into your Link Forest profile settings.
                                </p>
                            </div>
                        </section>
                    </div>
                </motion.div>
            </div>
        </div>
    );
};

export default GAGuide;
